import { render, staticRenderFns } from "./KeyCustom.vue?vue&type=template&id=5fb98dc4&"
import script from "./KeyCustom.vue?vue&type=script&lang=js&"
export * from "./KeyCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports